// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "premcalc-static/css/" + chunkId + "." + "2780be65" + ".chunk.css";
};